import { textFilterMatch } from "../utils";

const DROPDOWN_SIZE_ITEMS = 5;
const DROPDOWN_ITEM_HEIGHT = 46;
const DROPDOWN_SEARCHBAR_HEIGHT = 64;
const DROPDOWN_MARGIN = 100;

$(() => {
    initDropdowns();
})

function initDropdowns(): void {
    const dropdowns = $(".eui-dropdown");

    dropdowns.each((_, dropdown) => {
        $(dropdown).on("click", (event) => {
            const dropdownElement = $(event.currentTarget);
            const dropdownWrapper = $(dropdownElement.parent());
            const dropdownOptions = $(".eui-dropdown__options", dropdownWrapper);
            const inputContent = $(".eui-input-content", dropdownElement);
            if(dropdownElement.hasClass('eui-dropdown--open')) {
                // CLOSE
                closeDropdown(dropdownElement, dropdownOptions, dropdownWrapper);
            } else if(!inputContent.hasClass("eui-input-content--disabled")) {
                // OPEN
                dropdownWrapper.addClass('eui-dropdown-wrapper--open');
                dropdownElement.addClass('eui-dropdown--open');
                dropdownOptions.removeClass("eui-d-none");
                dropdownOptions.addClass("dropdown-options--open");

                const position = _getDropdownPosition(dropdownWrapper);
                dropdownOptions.css(position === 'top' ? 'bottom' : 'top', 'calc(100% + 4px)');
                dropdownOptions.css(position === 'top' ? 'top' : 'bottom', 'unset');

                setTimeout(() => {
                    handleDocumentClick(dropdownWrapper, dropdownElement, dropdownOptions);
                    handleOptionClick(dropdownWrapper, dropdownElement, dropdownOptions);
                    handleOptionsSearch(dropdownOptions);
                }, 100);
                handleLabelClick(dropdownWrapper);
            }
        })
    });
}

function closeDropdown(dropdownElement: any, dropdownOptions: any, dropdownWrapper: any): void {
    dropdownWrapper.removeClass('eui-dropdown-wrapper--open');
    dropdownElement.removeClass('eui-dropdown--open');
    dropdownOptions.addClass("eui-d-none");
    dropdownOptions.removeClass("dropdown-options--open");
    $(document.body).off('click');
    $(dropdownWrapper).off("click", ".eui-dropdown__option");
    $("[name='search']", dropdownOptions).off("input");
}

function handleOptionClick(dropdownWrapper: any, dropdownElement: any, dropdownOptions: any): void {
    $(dropdownWrapper).on("click", ".eui-dropdown__option", (event, emitEvents) => {
        event.stopPropagation();
  
        const optionValue = $(event.target).attr("data-eui-value")?.toString()!;
        const optionText = event.target.innerText;
  
        $(".eui-dropdown .eui-input", dropdownWrapper).val(optionText);
        $(".eui-dropdown .eui-input", dropdownWrapper).focus();
        $(".eui-dropdown .eui-input", dropdownWrapper).attr("eui-dropdown-val", optionValue);
        $(".eui-dropdown .eui-input", dropdownWrapper).change();
        $(".eui-dropdown .eui-input", dropdownWrapper).focusout();

        $(".eui-input-content", dropdownWrapper).addClass("eui-input-content--filled");

        closeDropdown(dropdownElement, dropdownOptions, dropdownWrapper);
    });
}

function handleOptionsSearch(dropdownOptions: any): void {
    const euiSearch = $(".eui-search", dropdownOptions);
    if(euiSearch) {
        const searchInput = $("[name='search']", dropdownOptions);
        searchInput.on("input", (event: any) => {
            $(".eui-dropdown__option", dropdownOptions).each((index, option) => {
                if (textFilterMatch($(option).text(), event.target.value)) {
                  $(option).show();
                } else {
                  $(option).hide();
                }
            });
        });
    }
}

function handleDocumentClick(dropdownWrapper: any, dropdownElement: any, dropdownOptions: any): void {
    $(document.body).on('click', (eventClick) => {
        if (!dropdownWrapper.is(eventClick.target) && !dropdownWrapper.has(eventClick.target).length)
            closeDropdown(dropdownElement, dropdownOptions, dropdownWrapper);
    });
}

function handleLabelClick(dropdownWrapper: any) {
    $(dropdownWrapper).on("click", ".eui-input-label", (event, _) => {
        event.preventDefault();
    });
}

export function resetDropdown(element: JQuery<any>) {
    setDropdownValue(element, "", "");
    $(".eui-input-error-message", element).addClass('eui-d-none');
}

export function enableDropdown(element: JQuery<any>) {
    const dropdownContent = $('.eui-input-content', element);
    const dropdownWrapper = $('.eui-input-wrapper', element);
    const dropdownInput = $('.eui-input', element);

    dropdownContent.removeClass("eui-input-content--disabled");
    dropdownWrapper.removeClass("eui-input-wrapper--disabled");
    dropdownInput.removeClass("eui-input--disabled");
}

export function disableDropdown(element: JQuery<any>) {
    const dropdownContent = $('.eui-input-content', element);
    const dropdownWrapper = $('.eui-input-wrapper', element);
    const dropdownInput = $('.eui-input', element);

    dropdownContent.addClass("eui-input-content--disabled");
    dropdownWrapper.addClass("eui-input-wrapper--disabled");
    dropdownInput.addClass("eui-input--disabled");
}
  
function setDropdownValue(element: JQuery<any>, text: string, value: string) {
    const euiInput = $(".eui-dropdown .eui-input", element);

    $(euiInput).val(text);
    $(euiInput).focus();
    $(euiInput).attr("eui-dropdown-val", value);
}

export function getDropdownValue(element: any): EuiDrodpownValue {
    const dropdownInput = $('.eui-input', element);
    const dropdownInputText = dropdownInput.text();
    const dropdownInputValue = dropdownInput.attr("eui-dropdown-val")!;

    return { text: dropdownInputText, value: dropdownInputValue };
}

function _getDropdownPosition(wrapper: JQuery<any>) {
    const windowHeight: number = window.innerHeight;
    const dropdownPosition: number = wrapper[0].getBoundingClientRect().top;
    const options = $(".eui-dropdown__options .eui-dropdown__option", wrapper);

    const dropdownSizeItems = Math.min(
        options.length,
        DROPDOWN_SIZE_ITEMS
    );
    const dropdownItemsHeight: number =
        DROPDOWN_ITEM_HEIGHT * dropdownSizeItems;
    const searchbarHeight: number = DROPDOWN_SEARCHBAR_HEIGHT;
    const totalHeight: number =
        dropdownPosition + dropdownItemsHeight + searchbarHeight;

    return windowHeight > totalHeight + DROPDOWN_MARGIN ? 'bottom' : 'top';
}

interface EuiDrodpownValue {
    value: string;
    text: string;
}